<template>
  <div>
    <div class="ant-upload ant-upload-select ant-upload-select-picture-card">
        <a href="javascript:;" class="file gradient">
          <img :src="fileUrl " alt="" class="img" >
          <input type="file"  ref="file" id="file"   @change="selectFile"/> <a-icon type="plus" style="font-size: 40px;color:#a9a9a9" v-if="fileUrl=='' " />
        </a>
      <span class="zz" v-if="fileUrl !=''">
        <a-icon type="edit" @click="edit" /> <a-icon type="delete" @click="dele" />
      </span>
    </div>
  </div>
</template>
<script>
import axiosUpload from 'axios';
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}
export default {
  name:"icon",
  data() {
    return{
      selectFileobj:[],
      filename:"",
      fileUrl:'',
      type:"",
      num:1
    }
  },
  methods:{
    selectFile(e) {
      let _this=this
         console.log(this.$refs['file'].files[0])
         if (this.$refs['file'].files[0]) {
           _this.filename = _this.$refs['file'].files[0].name
           _this.selectFileobj = _this.$refs['file'].files[0]
           let fd = new FormData()
           fd.append('file', _this.selectFileobj)
           fd.append('type', 4)
           this.type=""
           if(_this.beforeUpload( _this.selectFileobj)) {
             _this.importFile(fd)
             getBase64(_this.selectFileobj).then(res=>{
               _this.fileUrl= res
             })
           }
            } else {
              // this.Toleadform.filename = ''
           // this.$message.warning('请选择要上传的文件')
            }
        },


    importFile(file){
      let _this=this
      const instance=axiosUpload.create({
        withCredentials: true,
      })
      instance.interceptors.request.use(function (config) {
        config.headers.Authorization = window.sessionStorage.getItem('signature');
        return config;
      }, function (error) {
        return Promise.reject(error);
      });
      Promise.resolve(
      instance.post(this.$store.state.urlChang,file)).then(res=>{
        if(res.data.code == 200){
          // _this.fileUrl=res.data.data.url
          this.url=""
          this.$emit("fileList", res.data.data.url);
        }
      })

    },
    dele(){
      this.type="dele"
      this.fileUrl =''
      this.$emit("fileList", "");
      this.$refs['file'].value=""
    },
    edit(){
      // var e = document.createEvent('MouseEvent');
      // e.initEvent('click', false, false);
      // this.$refs.file.$el.dispatchEvent(e);
      // this.$refs['file'].click

      var e = document.createEvent('MouseEvents')
      e.initEvent('click', true, true)
      document.getElementById('file').dispatchEvent(e)
    },
    beforeUpload(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        this.$message.error('只能上传jpeg,jpg，png类型图片!');
        return false
      }

      const isLt2M = file.size < 204800;
      if (!isLt2M) {
        this.$message.error('图片必须小于 200kb!');
        return false
      }
      return new Promise(function (resolve,reject) {
        resolve(file)
      })
    },
     // this.$refs['file'].value = ''
  },
  mounted() {
  },
  props:["url"] ,
  watch:{
    url:function(newVal,oldVal){
      console.log("aaaaaaa",newVal,"bbbbbbb",oldVal)
      if(newVal&&oldVal==""){ }
      if(this.num==1){
        this.fileUrl =newVal ;
        this.num=2
      }

      // this.fileUrl =newVal ;
    },
  },
}
</script>
<style scoped>
.file {
  position: relative;
  display: inline-block;
  text-decoration: none;
  text-indent: 0;
  color: #333;

  display: inline-block;
  float: left;
  width: 104px;
  height: 104px;
  display: flex; align-items:center; justify-content:center


}
.file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;left: 0;width: 100%;
  opacity: 0;
  bottom: 0;
}
.zz{opacity: 0; background-color:rgba(0,0,0,0.4);position: absolute;top: 0;bottom: 0;left: 0;right: 0;display: flex; align-items:center; justify-content:center }
.zz i{display: inline-block;margin: 0 5px;color: #fff}
.ant-upload:hover .zz{opacity: 1}
.ant-upload{position: relative}
.img{position: absolute;max-height: 100%;max-width: 100%;top: 50%;left: 50%;transform:translate(-50%,-50%);}
</style>
